import {
  flattenErrors,
  FlexColumn,
  useCreateAndAddRefs,
} from '@equifinance/shared';
import styled from 'styled-components';
import PageErrors from '../Errors/PageErrors';
import ProductsLoanDetails from './ProductsLoanDetails';
import Products from './Products';
import EsisHistory from './EsisHistory';
import { ProductRefNames } from './ProductSidebar/ProductsSidebar';
import { useProductsContext } from '../../contexts';
import { EsisInfo, DocumentData } from '../../api/useDocumentsApi';

const Container = styled(FlexColumn)`
  width: 100%;
`;

export default function ProductsForm({
  esisInfos,
  handleDownloadEsis,
  handleProductSelected,
} : {
  esisInfos: EsisInfo[],
  handleDownloadEsis: (applicationId: string, productId: string) => Promise<DocumentData>,
  handleProductSelected: (productId: string) => void,
}) {
  const loanDetailsRef = useCreateAndAddRefs(ProductRefNames.LOAN_DETAILS);
  const productsRef = useCreateAndAddRefs(ProductRefNames.PRODUCTS);
  const esisHistoryRef = useCreateAndAddRefs(ProductRefNames.ESIS_HISTORY);

  const { productLoanDetails } = useProductsContext();
  const flattenedErrors = flattenErrors(productLoanDetails.errors);
  const flattenedWarnings = flattenErrors(productLoanDetails.warnings);

  return (
    <Container>
      <PageErrors id={productLoanDetails?.id} errors={flattenedErrors} warnings={flattenedWarnings} />

      <div id={ProductRefNames.LOAN_DETAILS} ref={loanDetailsRef}>
        <ProductsLoanDetails />
      </div>
      <div id={ProductRefNames.PRODUCTS} ref={productsRef}>
        <Products onDownloadEsis={handleDownloadEsis} onProductSelected={handleProductSelected} />
      </div>
      <div id={ProductRefNames.ESIS_HISTORY} ref={esisHistoryRef}>
        <EsisHistory esisInfos={esisInfos || []} />
      </div>
    </Container>
  );
}
